import useDestinationClipModal from "../destination/useDestinationClipModal";
import useExportLocations from "./useExportLocations";

/**
 * Drives the Clip Preview "Export" flow (deliver a copy to an approved export
 * location). A thin wrapper over the shared destination-clip modal, wired to
 * the export-locations source + POST /export.
 */
const useExportClipModal = () => {
  const { locations, loading, getLocations, exportAssets } =
    useExportLocations();

  return useDestinationClipModal({
    verb: "Export",
    locations,
    locationsLoading: loading,
    getLocations,
    submit: exportAssets,
    destinationLabel: "Export Destination",
    destinationDescription:
      "The approved Iconik export location these clips will be sent to.",
  });
};

export default useExportClipModal;
